var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.965,
    height: 33.963,
    viewBox: "0 0 32.965 33.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(-655.295 -263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_4787",
    "data-name": "Path 4787",
    transform: "translate(668.226 263) rotate(30)",
    fill: "none",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.134,18.877V6.983a1.018,1.018,0,0,0-.515-.88L12.057.131a.981.981,0,0,0-.981,0L.515,6.1A1.018,1.018,0,0,0,0,6.983V18.877a1.018,1.018,0,0,0,.515.88l10.561,5.972a.981.981,0,0,0,.981,0l10.561-5.972A1.018,1.018,0,0,0,23.134,18.877Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.56685256958008 23.70897483825684 L 21.13370323181152 18.29915428161621 L 21.13370323181152 7.561561107635498 L 11.56685256958008 2.151731967926025 L 2.00000262260437 7.561553955078125 L 2.00000262260437 18.29915428161621 L 11.56685256958008 23.70897483825684 M 11.56684875488281 25.86070823669434 C 11.39753723144531 25.86070823669434 11.22822761535645 25.81691360473633 11.07652282714844 25.72932243347168 L 0.5154825448989868 19.7573127746582 C 0.1985525637865067 19.57733345031738 0.001962569542229176 19.2416934967041 2.569580146882799e-06 18.87722396850586 L 2.569580146882799e-06 6.98348331451416 C 0.001962569542229176 6.61901330947876 0.1985525637865067 6.283383369445801 0.5154825448989868 6.103403091430664 L 11.07652282714844 0.1313831657171249 C 11.37993240356445 -0.0437968373298645 11.75376319885254 -0.0437968373298645 12.05718231201172 0.1313831657171249 L 22.61822319030762 6.103403091430664 C 22.93515205383301 6.283383369445801 23.13175201416016 6.61901330947876 23.13370323181152 6.98348331451416 L 23.13370323181152 18.87722396850586 C 23.13175201416016 19.24170303344727 22.9351634979248 19.57733345031738 22.61822319030762 19.7573127746582 L 12.05718231201172 25.72932243347168 C 11.90547275543213 25.81691360473633 11.73616027832031 25.86070823669434 11.56684875488281 25.86070823669434 Z",
    stroke: "none",
    fill: "#24b8c0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "question-solid",
    d: "M1.524,35.047a1.525,1.525,0,0,1,1.524-1.524h.762a1.525,1.525,0,0,1,1.524,1.524v.086a1.52,1.52,0,0,1-.7,1.281l-1,.645a2.1,2.1,0,0,0-.962,1.762v.036a.762.762,0,0,0,1.524,0v-.033a.574.574,0,0,1,.262-.481l1-.645a3.051,3.051,0,0,0,1.4-2.564v-.086A3.047,3.047,0,0,0,3.809,32H3.047A3.047,3.047,0,0,0,0,35.047a.762.762,0,0,0,1.524,0Zm1.9,7.618a.952.952,0,1,0-.952-.952A.952.952,0,0,0,3.428,42.666Z",
    transform: "translate(668.352 242.899)",
    fill: "#24b8c0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.54bde333ae9031e4f4f8d5f282478696.svg";
export { ForwardRef as ReactComponent };